var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"lyf-ui-button",class:[_vm.size, _vm.type, {
    disabled: _vm.disabled || _vm.loading
  }, {round: _vm.round}, {circle: _vm.circle}, {weak: _vm.weak}, {ghost: _vm.ghost}],attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[(_vm.loading)?_c('lyf-icon',{attrs:{"size":_vm.iconSize}},[_vm._v("")]):(_vm.icon)?_c('lyf-icon',{attrs:{"size":_vm.iconSize,"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }